module.exports = __webpack_public_path__ + "static/img/19.1b2265d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/19.png
// module id = UTfD
// module chunks = 0